<button [class]="buttonClass" (click)="setValue(!value)" [disabled]="disabled">
    <i class="dku-icon-sort-ascending-16" *ngIf="!value" title="Ascending order"></i>
    <i class="dku-icon-sort-descending-16" *ngIf="value" title="Descending order"></i>
</button>
